import { PlusIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import { SubCidItem } from "./SubCIDItem";

export const SubCIDBtn = ({
  isDisabled,
  setSubCidsHandler,
  startSubCID,
}: {
  isDisabled: boolean;
  startSubCID: string[];
  setSubCidsHandler: (subCids: string[]) => void;
}) => {
  const [isAddAllowed, setIsAddAllowed] = useState<boolean>(false);
  const [subCids, setSubCids] = useState<string[]>(startSubCID);

  useEffect(() => {
    setIsAddAllowed(
      subCids.length === 0 || subCids.every((subCid) => !!subCid),
    );
    setSubCidsHandler(subCids.filter((subCid) => subCid));
  }, [subCids]);

  const addHandler = () => {
    setSubCids((prev) => [...prev, ""]);
  };

  const onChange = (subCid: string, index: number) => {
    setSubCids((prev) => {
      const updatedCids = [...prev];
      updatedCids[index] = subCid;
      return updatedCids;
    });
  };

  const deleteHandler = (subCid: string) => {
    setSubCids((prev) => prev.filter((el) => el !== subCid));
  };

  return (
    <Stack gap={"32px"}>
      {subCids.length > 0 && (
        <Stack
          gap={"32px"}
          maxHeight={"214px"}
          overflow={"auto"}
          paddingTop={"24px"}
        >
          {subCids.map((subCid, index) => (
            <SubCidItem
              key={index}
              subCid={subCid}
              isDisabled={isDisabled}
              onChange={(subCid) => onChange(subCid, index)}
              onDelete={() => deleteHandler(subCid)}
            />
          ))}
        </Stack>
      )}

      <CustomButton
        onClick={addHandler}
        variant="outlined"
        customColor="#FFFFFF"
        textColor="#1D3E70"
        type="button"
        startIcon={
          <PlusIcon opacity={!isAddAllowed || isDisabled ? "0.6" : "1"} />
        }
        customSize="fit"
        disabled={!isAddAllowed || isDisabled}
        sx={{
          height: "32px",
          borderColor: "#1D3E70",
          padding: "8px 16px",
        }}
      >
        Add Sub-CID
      </CustomButton>
    </Stack>
  );
};
